/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button, Grid, MenuItem } from '@material-ui/core';
import { ChevronLeft } from '@material-ui/icons';
import SchoolIcon from '@material-ui/icons/SchoolRounded';
import { getClasses, getStudentsInviteSchool } from '@webapps/business';
import {
  Pagination,
  TextField,
  useAuth,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Team from 'components/Icons/Team';
import { useState } from 'react';

import CandidatsCard from './CandidatsCard';
import Nodata from 'components/NoData';
import theme from '../Classes/theme';

const STATUT_INVIT = [
  {
    label: 'Accepté',
    value: 'ACCEPTED',
  },
  {
    label: 'En attente',
    value: 'pending',
  },
  {
    label: 'Refusé',
    value: 'REJECTED',
  },
  {
    label: 'Annulé',
    value: 'CANCELED',
  },
];

const getYearsFromNowTo = (startYear) => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = currentYear; year >= startYear; year--) {
    years.push({ label: `${year}` });
  }
  return years;
};

const InviteStudentSchool = ({ forceShowNodata = false }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const {
    images: { Billings }
  } = theme

  const { idUser } = useAuth();
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(12);
  const [status, setStatus] = useState('all');
  const [email, setEmail] = useState('');
  const [group, setGroup] = useState('');
  const [year, setYear] = useState('');

  const {
    // status: load,
    data: { content: invites = [], totalElements } = {},
    refetch: refetch,
    // isFetching,
  } = useQuery(getStudentsInviteSchool, {
    key: ['inviteschoolstudent', page + idUser + status + email + group + year],
    variables: {
      id: idUser,
      page: page - 1,
      size,
      status,
      email,
      group,
      year,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });
  const {
    data: { content: classrooms = [] } = {},
    // isFetching,
  } = useQuery(getClasses, {
    key: ['teams'],
    variables: { id: idUser, page: page - 1, size: 8 },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const searchStatus = (e) => {
    if (e.target.value) {
      e.target.value === 'all' ? setStatus('all') : setStatus(e.target.value);
    }
  };

  const searchTeam = (e) => {
    if (e.target.value) {
      e.target.value === 'all' ? setGroup('') : setGroup(e.target.value);
    }
  };
  const searchYear = (e) => {
    if (e.target.value) {
      e.target.value === 'all' ? setYear('') : setYear(e.target.value);
    }
  };

  const goToPreviousPage = () => {
    window.history.back();
  };

  return (
    <div className={classes.container}>
      <div className={classes.paper}>
        <div className={classes.titleContainer}>
          <Button
            className={classes.returnButton}
            onClick={goToPreviousPage}
            startIcon={<ChevronLeft />}
          >
            Retour
          </Button>
          <div className={cx(global.title, classes.title)}>Liste des apprenants invités</div>
        </div>
        <div className={css({ marginBottom: spacing(2.5) })}>
          <Grid
            container
            spacing={1.3} // Gère l'espacement entre les inputs
            className={css({
              display: 'flex',
              // justifyContent: 'space-between',
              flexWrap: 'nowrap', // Empêche les inputs de passer à la ligne
              gap: '16px', // Espacement entre les inputs
              '@media only screen and (max-width:700px)': {
                flexWrap: 'wrap', // En dessous de 700px, les inputs passent à la ligne
                gap: '16px', // Espacement entre les inputs en mode wrap
              },
            })}
          >
            {/* <div className={classes.groupOfTwoInputs}> */}


            <div className={classes.textField}>
              <TextField
                fullWidth
                borderRadius={400}
                label="Adresse mail"
                variant="outlined"
                className={css({
                  width: 180,
                })}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className={classes.textField}>
              <TextField
                fullWidth
                borderRadius={400}
                label="Statut d'invitation"
                onChange={(e) => searchStatus(e)}
                select
                variant="outlined"
                className={css({
                  width: "180px",
                })}
              >
                <MenuItem value="all">
                  Tous
                </MenuItem>
                {STATUT_INVIT.map(({ label, value }, index) => (
                  <MenuItem
                    key={index}
                    value={value}
                  >
                    {label}
                  </MenuItem>
                ))}
              </TextField>
            </div>
            {/* </div> */}
            {/* <div className={classes.groupOfTwoInputs}> */}

            <div className={classes.textField}>
              <TextField
                fullWidth
                borderRadius={400}
                label="Classes"
                onChange={(e) => searchTeam(e)}
                select
                variant="outlined"

              >
                <MenuItem value="all">
                  Tous
                </MenuItem>
                {classrooms.map(({ label, id }, index) => (
                  <MenuItem
                    key={index}
                    value={id}
                  >
                    {label}
                  </MenuItem>
                ))}
              </TextField>
            </div>
            <div className={classes.textField}>
              <TextField
                fullWidth
                borderRadius={400}
                label="Année"
                onChange={(e) => searchYear(e)}
                select
                variant="outlined"
                className={css({
                  width: 180,
                })}
              >
                <MenuItem value="all">
                  Tous
                </MenuItem>
                {getYearsFromNowTo(2021).map(({ label }, index) => (
                  <MenuItem
                    key={index}
                    value={label}
                  >
                    {label}
                  </MenuItem>
                ))}
              </TextField>
            </div>
            {/* </div> */}
          </Grid>
        </div>
        <div
          className={css({
            marginTop: spacing(2.5),
          })}
        >
          {!invites?.length || forceShowNodata ? (
            <div
              className={css({
                backgroundColor: '#F3F7FF',
                borderRadius: 10,
                padding: spacing(2.5),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '300px',
              })}
            >
              <Nodata
                image={Billings}
                contentWidth='70%'
                padding='0px 20px 20px 0px'
                title="Aucun apprenant invité"
                description="Les invitations que vous avez envoyées aux apprenants s'afficheront ici."
              />
            </div>
          ) : (
            <Grid
              container
              style={{
                backgroundColor: '#F3F7FF',
                borderRadius: 10,
                padding: spacing(0, 0, 2.5, 2.5),
                marginBottom: spacing(2.5),
              }}
            >
              {invites.map(
                ({ groupId, inviteDate, status, student, id }, index) => (
                  <CandidatsCard
                    groupId={groupId}
                    inviteDate={inviteDate}
                    status={status}
                    student={student}
                    id={id}
                    refetch={refetch}
                  />
                )
              )}
            </Grid>
          )}
        </div>
        {invites?.length > 0 && !forceShowNodata && (
          <Pagination
            onChange={handlePaginationChange}
            page={page}
            pageCount={size}
            totalCount={totalElements}
          />
        )}
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    height: '100%',
    padding: '50px',
    '@media only screen and (max-width:1543px)': { padding: '42px' },
    '@media only screen and (max-width:1440px)': { padding: '34px' },
    minHeight: '100vh',
    lineHeight: '100%',
    '@media only screen and (max-width:768px)': { padding: spacing(2) },
  },
  paper: {
    padding: spacing(2.5),
    flex: '1 1 0px',
    borderRadius: 10,
    position: 'relative',
    background: 'white',
    '@media (max-width:768px)': { marginTop: spacing(2.5) },

  },
  containerSearch: {
    background: 'white',
    padding: spacing(3),
    paddingBottom: spacing(4),
    borderRadius: 10,
    marginTop: spacing(5),
  },
  title: {
    margin: 0,
    marginLeft: '140px',
    flex: 1,
  },
  searchContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  button: {
    borderRadius: '10.0px',
  },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'white',
    },
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: spacing(2),
    marginTop: '2px',
    marginBottom: '24px',
  },
  returnButton: {
    color: '#5A6DA1',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    border: '1px solid #C0D9FF',
    backgroundColor: 'white',
    borderRadius: '20px',
    width: '130px',
    fontWeight: 600,
    position: 'absolute',
    left: 20,
    top: 10,
    // '@media (max-width:768px)': {  },

  },
  textField: {
    width: "180px",

    '@media only screen and (max-width:700px)': {
      width: '100%', // Les inputs prennent toute la largeur en dessous de 700px
    },
  },
  groupOfTwoInputs: {
    display: 'flex',
    justifyContent: 'space-between', // Espacement uniforme
    flexWrap: 'nowrap', // Empêche le wrapping
    width: '100%',
    '@media only screen and (max-width:700px)': {
      flexWrap: 'wrap', // Les inputs passent à la ligne
    },
  },
});

export default InviteStudentSchool;
